module.exports = __webpack_public_path__ + "img/tx.rate.weekly.4d133683.png";